module.exports = __webpack_public_path__ + "static/media/cyuce016.dd17aad3.jpg";